import { render, staticRenderFns } from "./xjProductConfig.vue?vue&type=template&id=a3fb6826&scoped=true"
import script from "./xjProductConfig.vue?vue&type=script&lang=ts"
export * from "./xjProductConfig.vue?vue&type=script&lang=ts"
import style0 from "./xjProductConfig.vue?vue&type=style&index=0&id=a3fb6826&prod&lang=css"
import style1 from "./xjProductConfig.vue?vue&type=style&index=1&id=a3fb6826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb6826",
  null
  
)

export default component.exports